<div class="container">
  <img
    src="assets/state-images/modal_error_state.png"
    alt="An Error State Image"
  />
  <h1>Sorry...</h1>
  <p [innerHTML]="error"></p>
  <button *ngIf="link" [routerLink]="link" mat-flat-button>Try Again</button>
</div>
